export const fluffyPancakes = {
  id: "fluffyPancakes",
  link: "/#/recipes/recipes/fluffyPancakes",
  name: "Fluffy Pancakes",
  cuisine: "Tashikki",
  summary: "Small pancakes with a cinnamon honey sauce",
  inspiration: null,
  quantity: "6",
  time: "30 minutes",
  notes:
    "I had to include a recipe for pancakes. That was not optional. Most of the pancakes in Tashikk are going to be more like okonomiyaki or other things, rather than the pancakes found in the United States. But there is a single variety described as fluffy. I decided to replicate this one, since it would be familiar to most people. In order to get it to rise, I decided to use beaten egg whites. For a full explanation of how I justified using eggs for a Rosharan recipe, and why I couldn't use baking powder, gluten and yeast, or xanthan gum, see the Source Material page. For the dipping sauce, I went with a cinnamon-infused honey since we've already established the presence of honey. (Oathbringer, Rosharan Wines illustration)",
  quotes:
    "The third variety was fluffier, almost without any substance to it, though there was some kind of sauce to dip it in. (Edgedancer ch 8)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/pancake-overview.jpg",
  ingredientSections: [
    {
      title: "Pancakes",
      ingredients: [
        {
          item: "rice",
          display: "1 cup rice flour"
        },
        {
          item: "salt",
          display: "1/2 tsp salt"
        },
        {
          item: "sugar",
          display: "2 tsp granulated sugar"
        },
        {
          item: "water",
          display: "3/4 cup water"
        },
        {
          item: "vegetableOil",
          display: "2 tbsp vegetable oil"
        },
        {
          item: "eggs",
          display: "2 egg whites"
        }
      ]
    },
    {
      title: "Sauce",
      ingredients: [
        {
          item: "water",
          display: "1/4 cup water"
        },
        {
          item: "honey",
          display: "1/4 cup honey"
        },
        {
          item: "cinnamon",
          display: "1 small stick cinnamon"
        }
      ]
    }
  ],
  steps: [
    "In a bowl, combine rice flour, salt, sugar, 3/4 cup water, and vegetable oil. Mix until smooth.",
    "In a separate clean and dry bowl, beat the egg whites. Beat them just past stiff peaks, to the point where they're very thick but liquid hasn't started separating out yet.",
    "Grease an electric griddle and heat to 375 degrees Fahrenheit.",
    "Gently and carefully fold the egg whites into the batter, just until combined. There may still be some streaks of white.",
    "Carefully spoon some of the batter out onto the griddle into a circle shape. Repeat 5 more times to make 6 pancakes, using all of the batter.",
    "Cook until top is mostly set and bottom has started to brown. Flip, and cook until both sides have started to brown.",
    "While pancakes are cooking, to make the syrup, stir together 1/4 cup water, the honey, and cinnamon stick together in a saucepan over high heat. Bring to a boil, reduce heat to keep it from boiling over, and boil for 5 minutes. Remove from heat and let sit 10 minutes.",
    "To serve, remove the cinnamon stick from the sauce. Pour the sauce over the pancakes or dip them in it."
  ]
}
